import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { appendScript } from '../../../../utils/appendScript';
import ConvertTextToSpeech from '../../customeHooks/convertTextToSpeech';


const mapStateToProps = (state) => {
    const {
        answerCount,
        rightFeedbackProps,
        leftFeedbackProps,
    } = state.rootReducer.testPageDetails;

    return {
        answerCount,
        rightFeedbackProps,
        leftFeedbackProps,
    }
}

const LaDetailedFeedback = ({
    rightFeedbackProps: {
        correctAnswer,
        fileUrl,
        laDefaultFeedback: {
            combined_feedback,
            grammar_feedback,
            grammar_score,
            topic_feedback,
            topic_score,
            readability_feedback,
            readability_score,
            vocabulary_feedback,
            vocabulary_score,
            unique_words_feedback,
            unique_words_score,
            feedback,
        },
        score,
    },
    leftFeedbackProps: {
        questionId,
    },
}) => {
    useEffect(() => {
        appendScript('detailedFeedback');
        appendScript('tab-animation');
        ConvertTextToSpeech({ correctAnswer, elementClass: 'correct-answer-', questionId, score });
        let el = document.getElementById('laFeedbackList').querySelector('li')
        if (!!el) {
            el.classList.add('active')
            let elChild = el.getAttribute('data-target')
            document.getElementById(elChild).classList.add('current')
        }

    }, [correctAnswer,
        questionId,
        score
    ]);

    const feedbackColor = {
        'high': 'text-danger',
        'mid': '',
        'low': 'text-warning',
    }
    return (
        <span>
            {!!combined_feedback && <div className="tutor-feedback">
               <i className="fa fa-comments-o" aria-hidden="true"></i> 
               <p><span>Feedback</span>{combined_feedback}</p>
            </div>}

            {!!feedback && <div className="tutor-feedback">
               <i className="fa fa-comments-o" aria-hidden="true"></i> 
               <p><span>Feedback</span>{feedback}</p>
            </div>}
            
            <span className="feedbackLargeScreen">                 
              <ul className="panelNav" data-panelwrapper="panelWrapper5" id="laFeedbackList">
                   {!!grammar_feedback && <li data-target="grammar-div" > <a href="#grammar-div" className={`${feedbackColor[grammar_score]}`}>Grammar</a></li>}
                 {!!topic_feedback && <li data-target="ability-div"> <a href="#ability-div" className={`${feedbackColor[topic_score]}`} >Ability to Stay on topic</a></li>}
                 {!!readability_feedback && <li data-target="readability-div"> <a href="#readability-div" className={`${feedbackColor[readability_score]}`} >Readability</a></li>}
                 {!!vocabulary_feedback && <li data-target="vocabulary-div"> <a href="#vocabulary-div" className={`${feedbackColor[vocabulary_score]}`} >Vocabulary</a></li>}
                 {!!unique_words_feedback && <li data-target="uniquewords-div"> <a href="#uniquewords-div" className={`${feedbackColor[unique_words_score]}`} >Unique words used</a></li>}
              </ul>
              <div className="panelWrapper" id="panelWrapper5" data-enter="slideright" data-exit="slideright">
                {!!grammar_feedback && 
                 <div className="panel current" id="grammar-div">
                    <div className="pad-all width-80 mar-auto">
                       <p className="mar-top" dangerouslySetInnerHTML={{__html:   grammar_feedback}} />                             
                    </div>
                 </div>
                 }

                {!!topic_feedback && 
                 <div className="panel" id="ability-div">
                    <div className="pad-all width-80 mar-auto">
                       <p className="quote mar-top" dangerouslySetInnerHTML={{__html: topic_feedback}}/>
                    </div>
                 </div>}
                     

                 {!!readability_feedback && 
                    <div className="panel" id="readability-div">
                     <div className="pad-all width-80 mar-auto">
                          <p className="mar-top" dangerouslySetInnerHTML={{__html:  readability_feedback}} />  
                     </div>
                  </div>
                 }

                 {!!vocabulary_feedback && 
                  <div className="panel" id="vocabulary-div">
                     <div className="pad-all width-80 mar-auto">
                          <p className="mar-top" dangerouslySetInnerHTML={{__html: vocabulary_feedback}} />  
                     </div>
                  </div>
                 }

                 {!!unique_words_feedback && 
                  <div className="panel" id="uniquewords-div">
                     <div className="pad-all width-80 mar-auto">
                          <p className="mar-top" dangerouslySetInnerHTML={{__html:  unique_words_feedback}} />  
                     </div>
                  </div>}  
              </div>
            </span>
            <span className="feedbackMobile" style={{display:"none"}}>                 
              <ul className="panelNav" data-panelwrapper="panelWrapper5" id="laFeedbackList">
                   {!!grammar_feedback && 
                    <li data-target="grammar-div" > 
                       <a href="#grammar-div" className={`${feedbackColor[grammar_score]}`}>Grammar</a>
                        <div className="panel current" id="grammar-div">
                        <div className="pad-all width-80 mar-auto">
                           <p className="mar-top" dangerouslySetInnerHTML={{__html: grammar_feedback}} />                             
                        </div>
                        </div>
                   </li>}

                 {!!topic_feedback && 
                    <li data-target="ability-div"> 
                        <a href="#ability-div" className={`${feedbackColor[topic_score]}`} >Ability to Stay on topic</a>
                        <div className="panel" id="ability-div">
                        <div className="pad-all width-80 mar-auto">
                           <p className="quote mar-top" dangerouslySetInnerHTML={{__html: topic_feedback}}/>
                        </div>
                        </div>
                    </li>}

                 {!!readability_feedback && 
                    <li data-target="readability-div"> 
                        <a href="#readability-div" className={`${feedbackColor[readability_score]}`} >Readability</a>
                         <div className="panel" id="readability-div">
                         <div className="pad-all width-80 mar-auto">
                              <p className="mar-top" dangerouslySetInnerHTML={{__html:  readability_feedback}} />  
                         </div>
                          </div>
                    </li>}

                 {!!vocabulary_feedback && 
                    <li data-target="vocabulary-div"> 
                 <a href="#vocabulary-div" className={`${feedbackColor[vocabulary_score]}`} >Vocabulary</a>
                  <div className="panel" id="vocabulary-div">
                     <div className="pad-all width-80 mar-auto">
                          <p className="mar-top" dangerouslySetInnerHTML={{__html: vocabulary_feedback}} />  
                     </div>
                  </div>
                 </li>}
                 
                 {!!unique_words_feedback && 
                    <li data-target="uniquewords-div"> 
                    <a href="#uniquewords-div" className={`${feedbackColor[unique_words_score]}`} >Unique words used</a>
                    <div className="panel" id="uniquewords-div">
                     <div className="pad-all width-80 mar-auto">
                          <p className="mar-top" dangerouslySetInnerHTML={{__html:  unique_words_feedback}} />  
                     </div>
                  </div>
                  </li>}
              </ul>
              <div className="panelWrapper" id="panelWrapper5" data-enter="slideright" data-exit="slideright">
               
                      
              </div>
            </span>
        </span>
    )
}

export default connect(mapStateToProps)(LaDetailedFeedback);